import { render, staticRenderFns } from "./addServiceContact.vue?vue&type=template&id=883f3450"
import script from "./addServiceContact.vue?vue&type=script&lang=js"
export * from "./addServiceContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports